import { apiClient } from './client';

export interface PendingCorrection {
  id: number;
  officer_name: string;
  county: string; district: string; division: string; location: string;
  reported_figure: number;
  corrected_figure: number;
  reason: string | null;
  created_at: string;
}

export interface VerifyStats {
  pending_count: number;
  verified_count: number;
  rejected_count: number;
  pending: PendingCorrection[];
}

export const verifyApi = {
  async getVerifications(): Promise<VerifyStats> {
    return apiClient.get('/verify/');
  },

  /** Approves an officer's "Correct the unregistered figure" submission. Administrators only. */
  async approveRecord(correctionId: number) {
    return apiClient.post(`/population-corrections/${correctionId}/verify/`);
  },

  /** Rejects an officer's population-figure correction. Administrators only. */
  async rejectRecord(correctionId: number) {
    return apiClient.post(`/population-corrections/${correctionId}/reject/`);
  },
};
